<p-toast
  key="app"
  position="top-right"
  [life]="5000"
  [breakpoints]="{ '960px': { width: 'min(92vw, 22rem)' } }"
  styleClass="app-toast"
/>
<router-outlet />
